module.exports = __webpack_public_path__ + "e379a47d0af0e492905a88aff1d9817d.svg";